import React from 'react';

import { CustomerProfile } from '../CustomerPage/CustomerProfile';
import { UserProfile } from '../CustomerPage/UserProfile';
import { useCurrentUser } from '../../_services';

export const Account = ({ history, location: { pathname } }) => {
  const { customerId, currentUserIsCustomer, currentUser } = useCurrentUser();

  if (!currentUser) {
    return <div>Loading...</div>;
  }

  if (currentUserIsCustomer) {
    if (pathname === '/account' && customerId) {
      history.push(`/account/${customerId}`);
    }
    return <CustomerProfile id={customerId} />;
  }

  return <UserProfile id={currentUser.id} />;
};
